import './select.less';

import find from 'lodash/find';
import isNil from 'lodash/isNil';
import React from 'react';
import ReactSelect, { components, Creatable } from 'react-select';

import { CaretDownIcon } from 'zoomforth_component_lib/app_modern_icons.jsx';

import classNames from 'classnames';

const DropdownIndicator = (props) => {
  return (
    <components.DropdownIndicator {...props}>
      <CaretDownIcon />
    </components.DropdownIndicator>
  );
};

const StyledSelect = ({ className, dark, applyMenuPortal=true, components, ...props })=> {
  const { excludeDownCaret } = props;
  const indicator = !isNil(excludeDownCaret) ? DropdownIndicator : null;
  return (
    <ReactSelect
      components={{ indicator, ...components }}
      classNamePrefix={'zf-select' + (dark ? '-dark' : '')}
      className={classNames('zf-select', className, { dark })}
      menuPortalTarget={applyMenuPortal ? document.body : null}
      styles={{ menuPortal: (base) => ({ ...base, zIndex: 10000 }) }}
      {...props}
    />
  );
};

const LegacyCompatibilitySelect = ({ value, options, searchable, clearable, openOnFocus, ...props })=> (
  <StyledSelect
    value={find(options, ['value', value])}
    options={options}
    isClearable={clearable}
    isSearchable={searchable}
    openMenuOnClick={openOnFocus}
    {...props}
  />
);

const CreatableSelect = ({
  className,
  classNamePrefix,
  dark,
  components,
  value,
  options,
  searchable,
  clearable,
  onCreateOption,
  openOnFocus,
  ...props
})=> (
  <Creatable
    components={{ DropdownIndicator, ...components }}
    classNamePrefix={(classNamePrefix ? classNamePrefix : 'zf-select') + (dark ? '-dark' : '')}
    className={classNames('zf-select', className, { dark })}
    value={find(options, ['value', value])}
    formatCreateOption={(val)=> {
      return `Create ${val}...`;
    }}
    options={options}
    isClearable={clearable}
    isSearchable={searchable}
    openMenuOnClick={openOnFocus}
    onCreateOption={onCreateOption}
    // This fixes a z-index issue where the select menu from one select element is shown below
    //other select dropdowns
    menuPortalTarget={document.body}
    styles={{ menuPortal: base => ({ ...base, zIndex: 10000 }) }}
    {...props}
  />
);

export {
  StyledSelect,
  CreatableSelect,
  components
};

export default LegacyCompatibilitySelect;
